"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.results.total': 'Łączna liczba wyników',
};
